import React, {useState} from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const fromAndTo = [
    {caption: 'Москва', value: '1'},
    {caption: 'Berlin', value: '2'},
    {caption: 'Rome', value: '3'},
];

const aviaCompanies = [
    {caption: 'Aeroflot', value: '1'},
    {caption: 'S7', value: '2'},
    {caption: 'Ural-Airlines', value: '3'},
]

function App() {
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [from, setFrom] = useState<string | null>(null);
    const [where, setWhere] = useState<string | null>(null);
    const datePickerProps = {
        showTimeSelect: true,
        timeFormat:"HH:mm",
        timeIntervals: 15,
        timeCaption: "time",
        dateFormat: "MMMM d, yyyy h:mm aa",
    };
    return (
        <div className="App">
            <Container className="containerExtra">
                <h1>Flight finder</h1>
                <Stack gap={3} className="finderControlsRow">
                    <Row>
                        <Col xs={4}>
                            <Form.Select
                                onChange={({target}) => setFrom(target.value)}
                            >
                                <option className='selectPlaceHolder'>ОТКУДА</option>
                                {fromAndTo.map((el) => (
                                    <option value={el.value}>{el.caption}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col xs={4}>
                            <Form.Select
                                onChange={({target}) => setWhere(target.value)}
                            >
                                <option className={'selectPlaceHolder'}>КУДА</option>
                                {fromAndTo.map((el) => (
                                    <option value={el.value}>{el.caption}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col xs={4}>
                            <Form.Select>
                                <option className={'selectPlaceHolder'}>Авиакомпания</option>
                                {aviaCompanies.map((el) => (
                                    <option value={el.value}>{el.caption}</option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6}>
                            <Row>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    className="datePickerExtra"
                                    placeholderText={'КОГДА'}
                                    {...datePickerProps}
                                />
                            </Row>
                        </Col>
                        <Col xs={6}>
                            <Row>
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    className="datePickerExtra"
                                    placeholderText={'ОБРАТНО'}
                                    {...datePickerProps}
                                />
                            </Row>
                        </Col>
                    </Row>
                    <Row className='buttonRow'>
                        <Col>
                            <Button>Поиск</Button>
                        </Col>
                    </Row>
                </Stack>
                <div className={'py-2'}>Результаты:</div>
                <Stack direction={'horizontal'} className={'resultStack align-items-stretch'}>
                    <Col className={'resultCol d-flex flex-column justify-content-center'}>
                        <Row className={'gx-0 justify-content-center'}>{from ? fromAndTo[+from - 1].caption : null}</Row>
                        <Row className={'gx-0 justify-content-center'}>Время вылета: {'10:00'}</Row>
                    </Col>
                    <div className={'divider'}/>
                    <Col className={'resultCol d-flex flex-column justify-content-center'}>
                        <Row className={'gx-0 justify-content-center'}>{where ? fromAndTo[+where - 1].caption : null}</Row>
                        <Row className={'gx-0 justify-content-center'}>Время прилёта: {'21:30'}</Row>
                    </Col>
                    <div className={'divider'}/>
                    <Col className={'resultCol d-flex flex-column justify-content-center'}>
                        <Row className={'gx-0 justify-content-center'}>Эконом</Row>
                        <Row className={'gx-0 justify-content-center'}>Цена: {'100 руб'}</Row>
                    </Col>
                    <div className={'divider'}/>
                    <Col className={'resultCol d-flex flex-column justify-content-center'}>
                        <Row className={'gx-0 justify-content-center'}>Премиум</Row>
                        <Row className={'gx-0 justify-content-center'}>Цена: {'200 руб'}</Row>
                    </Col>
                    <div className={'divider'}/>
                    <Col className={'resultCol d-flex flex-column justify-content-center'}>
                        <Row className={'gx-0 justify-content-center'}>Бизнес</Row>
                        <Row className={'gx-0 justify-content-center'}>Цена: {'300 руб'}</Row>
                    </Col>
                </Stack>
            </Container>
        </div>
    );
}

export default App;
